/**
 * Styled Components - Created by jorge on 22/08/18.
 */
import styled from 'styled-components'
import { GRAY_DARK } from '../../theme/colors'

export const DeleteConfirmMessage = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/LogoutModal/styledComponents.tsx